if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.querySelector('.ga-media-zoom')?.addEventListener('pointerup', (event) => event.stopPropagation());
        this.querySelector('.ga-media-zoom')?.addEventListener('click', () => {
          const zoomed = this.classList.toggle('is-zoomed');
          const button = this.querySelector('.ga-media-zoom');
          button.setAttribute('aria-pressed', String(zoomed));
          button.textContent = zoomed ? button.dataset.fitLabel : button.dataset.zoomLabel;
          const container = this.querySelector('[role="document"]');
          const image = container.querySelector('img.active');
          requestAnimationFrame(() => {
            container.scrollLeft = zoomed && image ? Math.max(0, (image.offsetWidth - container.clientWidth) / 2) : 0;
            container.scrollTop = zoomed && image ? Math.max(0, (image.offsetHeight - container.clientHeight) / 2) : 0;
          });
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        this.classList.remove('is-zoomed');
        const zoomButton = this.querySelector('.ga-media-zoom');
        if (zoomButton) {
          zoomButton.hidden = activeMedia.tagName !== 'IMG';
          zoomButton.setAttribute('aria-pressed', 'false');
          zoomButton.textContent = zoomButton.dataset.zoomLabel;
        }
        if (!window.matchMedia('(max-width: 749px)').matches) activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollTop = 0;
        container.scrollLeft = window.matchMedia('(max-width: 749px)').matches ? 0 : (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
